import httpClient from '../api/httpClient'

const BASE_URL = '/refstories'

export const getDeceasedStories = (payload) => httpClient.get(`${BASE_URL}/${payload}/get`)
export const getAllDeceasedStories = (payload) => httpClient.get(`${BASE_URL}/getAll`)
export const deleteDeceasedStory = (payload) => httpClient.delete(`${BASE_URL}/delete/${payload.deceasedId}/${payload.storyId}`)

export default {
  getDeceasedStories,
  getAllDeceasedStories,
  deleteDeceasedStory
}
